window.loading = false;
function mrkPagination(){
    window.loading = true;
    $('.mrk-product-list').addClass('is-loading');
    $('.mrk-load-more-button').hide();
    $('.mrk-loader').show();
    $.ajax({
        url: $('.mrk-loader').attr('next-url'),
        method: 'get',
        success: function(response) {
            window.loading = false;
            var html = $.parseHTML(response);
            const products = $(html).find('.mrk-product-list').html();
            const pagination = $(html).find('.mrk-pagination').html();
            $('.mrk-product-list').append(products);
            initSwatches();
            $('.mrk-pagination').html(pagination);
            $('.mrk-product-list').removeClass('is-loading');
            if($('.mrk-loader').attr('next-url') != ''){
              $('.mrk-load-more-button').show();
            }

            $('.mrk-load-more-button').click(function(){
              mrkPagination()
            });    
            // checkScroll()
        }
    });
}

function checkScroll() {
  return;
    if ($('.mrk-pagination').length && $('.mrk-loader').attr('next-url') != undefined) {
          let options = {
              root: null, // Use the viewport as the root
              rootMargin: '0px', // No margin
              threshold: 0.1 // Trigger when at least 10% of the element is visible
          };

          // Create the Intersection Observer
          let observer = new IntersectionObserver((entries, observer) => {
              entries.forEach(entry => {
                  if (entry.isIntersecting && $('.mrk-loader').attr('next-url') != undefined && window.loading == false) {
                      // Run the pagination function
                      mrkPagination();
                      console.log('mrk-helloo new');
                      // Unobserve the current target if you only want to load once
                      observer.unobserve(entry.target);
                  }
              });
          }, options);

          // Observe the target element
          let target = document.querySelector('.mrk-loader');
          if (target) {
              observer.observe(target);
          }
    } else {
        $('.mrk-loader').hide();
    }
}
function mrkSort(){
    window.loading = true;
    $('.mrk-product-list').addClass('is-loading');
    let url = new URL(window.location.href);
    url.searchParams.set('sort_by', $('.mrk-sort-button').val());
    $.ajax({
        url: url,
        method: 'get',
        success: function(response) {
            window.loading = false;
            var html = $.parseHTML(response);

            const products = $(html).find('.mrk-product-list').html();
            const pagination = $(html).find('.mrk-pagination').html();
            $('.mrk-product-list').html(products);
            initSwatches();
            $('.mrk-pagination').html(pagination);
            $('.mrk-product-list').removeClass('is-loading');
            checkScroll()

            $('.mrk-load-more-button').click(function(){
              mrkPagination()
            });    
        }
    });
}

$('.mrk-sort-button').change(function(){
  mrkSort()
});

$('.mrk-load-more-button').click(function(){
  mrkPagination()
});

const myEvent = new CustomEvent("myCustomEvent", {
  detail: { message: "Hello from custom event!" }, // Optional data
});

document.addEventListener("myCustomEvent", function (event) {
  $('.mrk-load-more-button').click(function(){
    mrkPagination()
  });
});
// checkScroll();